"use client";

import { buttonVariants } from "@/components/ui";
import { cn } from "@/lib/cn";
import { useAuthModal } from "@/features/auth/auth-modal";

/** Nút Đăng nhập / Đăng ký ở header — mở modal ngay tại trang (không redirect). */
export function HeaderAuthButtons() {
  const { openAuth } = useAuthModal();
  return (
    <>
      <button
        type="button"
        onClick={() => openAuth("login")}
        className={cn(buttonVariants({ variant: "tertiary", size: "sm" }), "hidden sm:inline-flex")}
      >
        Đăng nhập
      </button>
      <button type="button" onClick={() => openAuth("register")} className={buttonVariants({ size: "sm" })}>
        Đăng ký
      </button>
    </>
  );
}
